const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {(key: string, opts?: object) => string} t — i18n `t` for `servicePage.requestModal.*`
 * @returns {import('react-hook-form').Resolver<{
 *   requesterType: string,
 *   name: string,
 *   companyName: string,
 *   email: string,
 *   requirements: string,
 *   description: string,
 * }>}
 */
export function createServiceRequestModalResolver(t) {
  return function serviceRequestModalResolver(values) {
    const requesterType =
      values.requesterType === "individual" ? "individual" : "company";
    const name = String(values.name ?? "").trim();
    const email = String(values.email ?? "").trim();
    const companyName = String(values.companyName ?? "").trim();
    const requirements = String(values.requirements ?? "").trim();
    const description = String(values.description ?? "").trim();

    /** @type {import('react-hook-form').FieldErrors<typeof values>} */
    const errors = {};

    if (!name) {
      errors.name = {
        type: "required",
        message: t("servicePage.requestModal.valNameRequired"),
      };
    }
    if (!email || !EMAIL_RE.test(email)) {
      errors.email = {
        type: "pattern",
        message: t("servicePage.requestModal.valEmailInvalid"),
      };
    }
    if (requesterType === "company" && !companyName) {
      errors.companyName = {
        type: "required",
        message: t("servicePage.requestModal.companyRequired"),
      };
    }
    if (!requirements) {
      errors.requirements = {
        type: "required",
        message: t("servicePage.requestModal.valRequirementsRequired"),
      };
    }
    if (!description) {
      errors.description = {
        type: "required",
        message: t("servicePage.requestModal.valDescriptionRequired"),
      };
    }

    if (Object.keys(errors).length > 0) {
      return { values: {}, errors };
    }

    return {
      values: {
        requesterType,
        name,
        email,
        companyName: requesterType === "company" ? companyName : "",
        requirements,
        description,
      },
      errors: {},
    };
  };
}
